import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  openModal: `${NAMESPACE}_OPEN_LOGOFF_MODAL`,
  closeModal: `${NAMESPACE}_CLOSE_LOGOFF_MODAL`,
  setTimeToCountdown: `${NAMESPACE}_SET_TIME_TO_LOGOUT_COUNTDOWN`,
  setTime: `${NAMESPACE}_SET_TIME_TO_LOGOUT`,
};

export const actionCreators = {
  openModal: payload => ({ type: actions.openModal, payload }),
  closeModal: payload => ({ type: actions.closeModal, payload }),
  setTimeToCountdown: payload => ({ type: actions.setTimeToCountdown, payload }),
  setTime: payload => ({ type: actions.setTime, payload }),
};

export default {
  actions,
  actionCreators,
};
